import { Typography } from "@mui/material";
import React from "react";
import CustomTable from "../../components/CustomTable";
import MainLayout from "../../components/MainLayout";
import { formatCustomDate } from "../../utils/formatters";

export default function Permissions() {
  const columns = [
    { field: "id", headerName: "ID", width: 70, type: "number" },
    { field: "name", headerName: "Name", width: 500 },
    {
      field: "created_at",
      headerName: "Created At",
      width: 500,
      valueGetter: (value) => value && new Date(value),
      renderCell: (value) => formatCustomDate(value.row.created_at),
      type: "date",
    },
  ];

  return (
    <MainLayout>
      <Typography variant="h6">Permissions</Typography>

      <CustomTable columns={columns} fetchDataUrl="permissions-paginated" />
    </MainLayout>
  );
}
